import { useQuery } from "@tanstack/react-query";
import { getServiceTemplateStatistics } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
/**
 * Read service statistics via RCB Service API.
 */ function useServiceTemplateStatistics(favouritesOnly = false) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.getServiceStatistics(favouritesOnly), ({ signal })=>getServiceTemplateStatistics({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                favouritesOnly
            }
        }), {
        retry: false,
        refetchOnMount: true
    });
}
export { useServiceTemplateStatistics };
